/*
    创建者：shuxiaokai
    创建时间：2020-05-14 17:55
    模块名称：小组件
    备注：xxxx
*/
<template>
    <div class="context-item" @click.stop="handleClick">
        <div>{{ label }}</div>
        <div class="ml-auto gray-500">{{ shortcut }}</div>
    </div>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            default: ""
        },
        shortcut: {
            type: String,
            default: ""
        },
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        handleClick() {
            this.$emit("click");
        },
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.context-item {
    height: size(28);
    line-height: size(28);
    padding: size(0) size(20);
    cursor: pointer;
    display: flex;
    &:hover {
        color: $theme-color;
        background: rgba(0, 0, 0, .05);
    }
}
</style>
